import React from 'react'

export default function AdminConfigStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .admin-config-container {
          display: flex;
        }

        .left-wrapper {
          display: flex;
          flex-direction: column;
          flex: 2.5;
          margin-right: 50px;
        }

        .right-wrapper {
          display: flex;
          flex-direction: column;
          /*background-color: red;*/
          flex: 4;
          disable: true;
        }

        .control-wrapper {
          display: flex;
          flex-direction: column;
          border-left: solid 0.5px blue;
          margin-bottom: 5px;
        }
        .control-wrapper.last{ margin-bottom: 0; }
        .control-wrapper.module { border-left: solid 0.5px pink; }
        .control-wrapper .table { font-size: 0.85rem; }

        .control-header-title {
          text-align: left;
          padding: 5px;
          padding-left: 15px;
          font-size: 1rem;
          background-color: rgba(0, 0, 255, 1);
          color: white;
          border: none;
        }
        .control-header-title:hover { background-color: rgba(0, 0, 200, 1); }
        .module .control-header-title {
          display: flex;
          background-color: rgba(255,192,203, 1);
          color: black;
        }
        .module .control-header-title:hover { background-color: rgba(255,152,203, 1); }
        .module-name { flex: 2; }

        .modules-option {
          padding-left: 5px;
          display: flex;
          background-color: lightgreen;
          font-size: 1rem;
          margin-bottom: 2px;
        }
        .modules-option.last { margin-bottom: 0; }
        .options-name {
          padding: 3px;
          font-size: 1rem;
          flex: 2;
        }

        .fields-container {
          display: flex;
          padding: 10px;
          flex-direction: column;
        }
        .fields-container input:first-child {
          font-size: 1rem;
          margin: 2px;
          margin-top: 0;
        }
        .fields-container select:disabled { color: grey; opacity: 1; }
        .fields-container select { padding: 3px; }
        .fields-container input { padding: 3px 7px; }
        .fields-container input, select {
          font-size: 1rem;
          margin: 2px;
          border: solid 1px lightgrey;
        }
        .fields-container input:last-child {
          font-size: 1rem;
          margin: 2px;
          margin-bottom: 0px;
        }

        .module-title-container {
          background-color: lightgreen;
        }

        .action-button-container {
          display: flex;
          justify-content: flex-end;
          margin-top: 5px;
        }

        /* fc - Field Container */
        .hide-fc { display: none; }

        .read-only {
          background-color: #EEE;
          color: grey; /*#222;*/
        }
        .disabled {
          pointer-events: none;
          opacity: 0.4;
        }
        .disabled * { color: grey; }

        .focus {
          background-color: #F2F2F2;
          color: blue;
        }

        .change-user-password {
          width: 120px;
          margin-left: 2px;
          padding: 3px;
        }
        .change-password-group-button {
          margin: 2px;
          display: flex;
          justify-content: flex-end;
        }

        .error-notification {
          font-size: 0.9rem;
          color: red;
          border: solid 0.5px red;
          padding: 5px;
          margin: 5px;
          text-align: left;
        }
      `}
      </style>
    </React.Fragment>
  )
}
